import { 
  getText,
  appendText,
} from '../../../assets/js/text-renderer';

import './compute.scss';
import '../../shared/sub-navbar/sub-navbar';
import { setToggleContentListener } from '../../shared/sub-navbar/sub-navbar-toggle-content';
import { setCloseAlertListener } from '../../shared/cta-hero';
import landComputeHTML from './landing-compute.html';
import featComputeHTML from './features-compute.html';
import priceComputeHTML from './pricing-compute.html';
import { loadText as loadLandingContent } from './landing-compute';
import { loadText as loadFeatureContent } from './features-compute';
import { loadText as loadPricingContent } from './pricing-compute';
import '../../shared/cta/cta';

document.addEventListener('DOMContentLoaded', async () => {
  if (
    DEVELOPMENT || (
    window['__PRERENDER_INJECTED'] && 
    window['__PRERENDER_INJECTED'].render_text)
  ) {
    // Get main tags
    const landingEl = document.getElementById('landing-compute-content');
    const featuresEl = document.getElementById('features-compute-content');
    const pricingEl = document.getElementById('pricing-compute-content');

    // Render main contents
    landingEl.innerHTML = landComputeHTML;
    featuresEl.innerHTML = featComputeHTML;
    pricingEl.innerHTML = priceComputeHTML;

    await setContent(landingEl, featuresEl, pricingEl);
  }

  const sections = document.querySelectorAll('main');
  setToggleContentListener(sections);
  setCloseAlertListener();
});

const setContent = async (landingEl, featuresEl, pricingEl) => {
  await setSubNavBarContent();

  // Load text contents
  const ctaButtonsData = await getText('platform/shared/cta-buttons');
  const ctaButtons = ctaButtonsData.stories[0].content;

  await loadLandingContent(landingEl, ctaButtons);
  await loadFeatureContent(featuresEl, ctaButtons);
  await loadPricingContent();
  await setCustomCtaContent();

  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'keywords' })
  );
  window.dispatchEvent(
    new CustomEvent('rendered-text', { detail: 'content' })
  );
};

async function setSubNavBarContent() {
  const data = await getText('platform/shared/sub-navbar');
  const content = data.stories[0].content;

  appendText(content.general, 'landing-link');
  appendText(content.features, 'features-link');
  appendText(content.pricing, 'pricing-link');
};

async function setCustomCtaContent() {
  const ctaData = await getText('platform/shared/cta');
  const ctaContent = ctaData.stories[0].content.block[0];

  const customCtaContainer = document.getElementById('custom-cta');
  const customCtaEl = document.createElement('custom-cta');
  customCtaEl.setAttribute('title', ctaContent.title)
  customCtaEl.setAttribute('description', ctaContent.description)
  customCtaEl.setAttribute('primary-button-text', ctaContent.btn_primary)
  customCtaEl.setAttribute('primary-button-url', '/plataforma/start-trial/')
  customCtaEl.setAttribute('secondary-button-text', ctaContent.btn_secondary)
  customCtaEl.setAttribute('secondary-button-url', '/plataforma/book-demo-form/')
  customCtaContainer.appendChild(customCtaEl);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
};